export type AssetDetailTabKey =
  | 'incidents'
  | 'components'
  | 'logs'
  | 'commands'
  | 'ocpp-configuration'
  | 'details'
  | 'ocpp-auth';

export const DEFAULT_ASSET_DETAIL_TAB: AssetDetailTabKey = 'incidents';
export const ASSET_DETAIL_LOCATION_SECTION_ID = 'asset-detail-location';

const ALL_KEYS: AssetDetailTabKey[] = [
  'incidents',
  'components',
  'logs',
  'commands',
  'ocpp-configuration',
  'details',
  'ocpp-auth',
];

export function parseAssetDetailTabParam(
  raw: string | null,
): AssetDetailTabKey | null {
  if (!raw) return null;
  return (ALL_KEYS as string[]).includes(raw)
    ? (raw as AssetDetailTabKey)
    : null;
}

export function buildAssetDetailTabKeys(input: {
  showIncidents?: boolean;
  showCommands: boolean;
  showOcppConfiguration: boolean;
  showOcppAuth: boolean;
}): AssetDetailTabKey[] {
  const showIncidents = input.showIncidents ?? true;
  return ALL_KEYS.filter((key) => {
    if (key === 'incidents') return showIncidents;
    if (key === 'commands') return input.showCommands;
    if (key === 'ocpp-configuration') return input.showOcppConfiguration;
    if (key === 'ocpp-auth') return input.showOcppAuth;
    return true;
  });
}

export function resolveAssetDetailTabKey(input: {
  requested: string | null;
  showIncidents?: boolean;
  showCommands: boolean;
  showOcppConfiguration: boolean;
  showOcppAuth: boolean;
}): AssetDetailTabKey {
  const parsed = parseAssetDetailTabParam(input.requested);
  const allowedKeys = buildAssetDetailTabKeys({
    showIncidents: input.showIncidents,
    showCommands: input.showCommands,
    showOcppConfiguration: input.showOcppConfiguration,
    showOcppAuth: input.showOcppAuth,
  });
  const allowed = new Set(allowedKeys);
  if (parsed && allowed.has(parsed)) return parsed;
  if (allowed.has(DEFAULT_ASSET_DETAIL_TAB)) return DEFAULT_ASSET_DETAIL_TAB;
  return allowedKeys[0] ?? 'details';
}
